import { motion } from "framer-motion";
import { Link } from "react-router-dom";


export default function ProjectNextButton({
    project
}){


    return(
        <Link
            className="group"
            to="/ProjectDetails"
            state={{selectedProject: project}}
        >
            <div
                className="
                    relative
                    overflow-hidden
                "
            >
                <div
                    className="
                        absolute
                        w-full
                        h-full
                        blur-lg
                    "
                >
                    <div
                        className="
                            w-full
                            h-full
                        "
                    >
                        <motion.img
                            className="
                                h-full
                                w-full
                                object-cover
                                scale-125

                                transition-transform
                                duration-300
                                ease-in-out
                                group-hover:scale-110
                            "
                            src={project.screenshots? project.screenshots[0].src : project.mobileScreenshots[0].src}
                            alt="Project Blurred Background"
                        />
                    </div>
                </div>


                {/* Black Background Overlay */}
                <div
                    className="
                        absolute
                        w-full
                        h-full
                        bg-black/40
                    "
                    />



                <div
                    className="
                        h-full
                        w-full
                        flex
                        flex-col
                        justify-center
                        items-center

                        text-white

                        py-20

                    "
                >
                    <span
                        className="
                            z-10
                            tracking-wider
                            pb-2
                            text-xs
                            sm:text-sm


                            transition-transform
                            duration-300
                            ease-in-out
                            group-hover:scale-90
                        "
                    >
                        Next Project
                    </span>
                    <span
                        className="
                            text-2xl
                            sm:text-4xl
                            z-10
                            uppercase
                            tracking-widest
                            font-medium


                            transition-transform
                            duration-300
                            ease-in-out
                            group-hover:scale-110
                        "
                    >
                        {project.title}
                    </span>
                </div>




            </div>
        </Link>
    );

}